import { LaboratoryHttpHeaderModel } from 'app/core/services/prothesis-api/laboratory-http-header-model';
import { TimeZoneDateFnsService } from 'app/core/services/time-zone-date-fns.service';
import { ProductType } from 'app/shared/enums/product-type.enum';
import { SubscriptionBannerModel } from './subscription-banner.model';

export class SubscriptionBannerModelHelper {
  public static fromHttpHeader(laboratoryHttpHeader: LaboratoryHttpHeaderModel | null | undefined): SubscriptionBannerModel {
    const subscriptionBanner = new SubscriptionBannerModel();
    if (laboratoryHttpHeader?.lastSubscriptionEndDate) {
      const lastSubscriptionEndDate = TimeZoneDateFnsService.toLaboratoryTimeZone(laboratoryHttpHeader.lastSubscriptionEndDate);
      subscriptionBanner.lastSubscriptionEndDate = TimeZoneDateFnsService.addTime(lastSubscriptionEndDate, 0, 0, 0, -1);
      subscriptionBanner.lastActiveSubscriptionDaysLeft = TimeZoneDateFnsService.diffDaysBetweenNow(lastSubscriptionEndDate);
    } else if (laboratoryHttpHeader?.lastSubscriptionEndDate === null) {
      subscriptionBanner.lastActiveSubscriptionDaysLeft = null;
    }

    if (laboratoryHttpHeader?.subscriptionEndDate) {
      subscriptionBanner.activeSubscriptionExistenceFlag = true;
    } else {
      subscriptionBanner.activeSubscriptionExistenceFlag = false;
    }

    subscriptionBanner.suspendedFlag = laboratoryHttpHeader?.suspendedFlag;

    if (laboratoryHttpHeader?.lastNonFreeSubscriptionProductType) {
      const productType = parseInt(laboratoryHttpHeader.lastNonFreeSubscriptionProductType, 10);
      if (Number.isInteger(productType) && Object.values(ProductType).includes(productType)) {
        subscriptionBanner.lastActiveSubscriptionDisplayLabel = productType === ProductType.Discovery ? 'essai gratuit' : 'abonnement';
      } else {
        subscriptionBanner.lastActiveSubscriptionDisplayLabel = 'abonnement';
      }
    } else {
      subscriptionBanner.lastActiveSubscriptionDisplayLabel = 'abonnement';
    }

    if (
      !laboratoryHttpHeader ||
      laboratoryHttpHeader.lastSubscriptionEndDate === undefined ||
      laboratoryHttpHeader.lastNonFreeSubscriptionProductType === undefined
    ) {
      subscriptionBanner.displayFlag = false;
    } else {
      if (
        subscriptionBanner.suspendedFlag ||
        !subscriptionBanner.activeSubscriptionExistenceFlag ||
        (subscriptionBanner.activeSubscriptionExistenceFlag && subscriptionBanner.lastActiveSubscriptionDaysLeft! < 31)
      ) {
        subscriptionBanner.displayFlag = true;
      } else {
        subscriptionBanner.displayFlag = false;
      }
    }

    subscriptionBanner.cssClass =
      !subscriptionBanner.suspendedFlag &&
      subscriptionBanner.activeSubscriptionExistenceFlag &&
      7 < subscriptionBanner.lastActiveSubscriptionDaysLeft! &&
      subscriptionBanner.lastActiveSubscriptionDaysLeft! < 31
        ? 'black'
        : '';

    return subscriptionBanner;
  }
}
